export default class RobinhoodApi {
  static fetchData(token: string, path: string, callback: object) {
    fetch('https://us-central1-screener-c9321.cloudfunctions.net/robinhoodForward', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({path, token}),
    }).then(rsp => {
        if (rsp.status !== 200) {
          console.error("Failed to fetch data");
        }

        return rsp.json();
      })
      .then(json => callback(json.data));
  }
}



// WEBPACK FOOTER //
// ./src/lib/RobinhoodApi.js